export default {
	GET_ALL: (groupId) => `/split/expense/all?groupId=${groupId}`,
	CREATE: (groupId) => `/split/expense?groupId=${groupId}`,
	UPDATE: () => "/split/expense",
	DELETE: (expenseId) => `/split/expense/${expenseId}`,
};
